import { holdsAt } from "@/lib/is-available-at";
import { Availability } from "@/types";

/**
 * Checks if a set of availability IDs indicates availability at the current day/time.
 * If `availabilityIds` is empty or undefined, the entity is considered always available.
 * Returns true if ANY matched availability has the current day+time within its schedule.
 *
 * GRANULARITY: minutes, inclusive on both ends. Clock and bounds are both cut to
 * "HH:MM" — seconds never decide whether a window holds.
 *
 * TIMEZONE: the clock is the TENANT's, from `scheduling-context.timezone`, and the
 * windows are normalized from whichever format the payload carries — UTC time-of-day
 * (`HH:MM:SS.000Z`) or the legacy wall clock (§9.1). The customer's browser zone no
 * longer decides what is on the menu.
 *
 * Unlike `isAvailableAt`, the `startDate`/`endDate` validity is NOT applied here:
 * "now" is always inside the season a merchant is currently selling.
 */
export function isAvailableNow(
  availabilityIds: string[] | undefined,
  availabilities: Availability[],
  now: Date = new Date(),
  timeZone?: string | null,
): boolean {
  return holdsAt(availabilityIds, availabilities, now, timeZone, false);
}
